export default "__VITE_ASSET__542bbe11__"